import React from 'react';
import Log from './Log';

const _checkLengthLimit = 500;

export default class CheckLog extends React.PureComponent {
  static get lengthLimit() {
    return _checkLengthLimit;
  }

  formattedReport(rep) {
    if (rep.length < CheckLog.lengthLimit) {
      return this.splitReport(rep);
    }
    return this.splitReport(`${rep.substr(0, CheckLog.lengthLimit - 1)} \u2026`);
  }


  splitReport(rep) {
    var repArr = rep.trim().split("\n");
    var thisMessage = [];
    for (var i = 0; i < repArr.length; i++){
      if (i == repArr.length - 1){
        thisMessage.push(repArr[i]);
      }else{
        thisMessage.push(repArr[i]);
        thisMessage.push(<br/>);
        thisMessage.push(<br/>);
      }
    }
    return thisMessage;
  }

  render() {
    return (<Log
      color
      heading={this.props.heading}
      title={this.props.title}
    >
      <p className="checks-description">
        <strong>Explanation:</strong> {this.props.description}
      </p>
      { this.props.notes ?
        <p className="checks-notes" style={{ fontVariant: 'none' }}>
          <strong>Notes:</strong> {this.formattedReport(this.props.notes)}
        </p> : null}
    </Log>);
  }
}
